import { filterEmpty, getSearchParam } from "@/utils";
import { Toast } from "antd-mobile";
import { keyDidAtom, positionAtom, refreshLocAtom, toggleCityAtom } from "../app";
import { _latitude, _longitude, keyAid, keyBid, keyCid, keyDid, keyId } from "../common";
import { loadLocation } from "./loadLocation.ts";
import { useApiMap } from "../hooks/useApiMap";
import { jotaiStore } from "@/atoms/store.ts";
const { get } = jotaiStore;
function isPositionZero(pos: any) {
  return pos !== null && pos !== undefined && pos.latitude === 0 && pos.longitude === 0;
}

function hasGeoParams() {
  return !isEmptyType(_latitude) && !isEmptyType(_longitude);
}

function hasKeyId() {
  return !isEmptyType(keyId);
}

function needFallback(position: any) {
  return (
    (isEmptyType(_latitude) && isEmptyType(_longitude) && hasKeyId()) ||
    ((isEmptyType(position) || isPositionZero(position)) && hasGeoParams() && hasKeyId())
  );
}
async function fetchFallback(position: any) {
  const refreshloc = get(refreshLocAtom);
  const toggleCity = get(toggleCityAtom);
  const params = {
    keyId,
  };
  if (needFallback(position) && !refreshloc && !toggleCity) {
    useApiMap(params);
  }
  const params1 =
    _latitude && _longitude
      ? {
          test: isDevEnv ? 1 : undefined,
          type: (refreshloc || toggleCity) && !position?.latitude && !position?.longitude ? "server" : "geo",
          latitude: refreshloc || toggleCity ? "" : _latitude,
          longitude: refreshloc || toggleCity ? "" : _longitude,
          search: position ? `${position?.latitude},${position?.longitude}` : "",
          clientIp: getSearchParam("clientIp"),
        }
      : {
          test: isDevEnv ? 1 : undefined,
          type: position && position?.latitude && position?.longitude ? "geo" : "server",
          search: position ? `${position?.latitude},${position?.longitude}` : "",
          clientIp: getSearchParam("clientIp"),
        };
  const params2 = filterEmpty(params1);
  const resData: any = await loadLocation(params2);
  LocalStorage.setItem("KEY_ID", resData?.info?.key);
  if (keyAid || keyBid || keyCid || keyDid) {
    LocalStorage.removeItem("KEY_ID");
  }
  const params3 = {
    keyId: resData?.info?.key,
    keyDid: jotaiStore.get(keyDidAtom),
  };
  useApiMap(params3);
}

export default async function loadDataByGeo() {
  const { latitude, longitude } = get(positionAtom);
  const position = { latitude: latitude || 0, longitude: longitude || 0 };
  return new Promise(async (resolve, reject) => {
    try {
      if (jotaiStore.get(toggleCityAtom)) {
        return resolve(null);
      }
      const res = await fetchFallback(position);
      resolve(res);
    } catch (err: unknown) {
      const error = err instanceof Error ? err : new Error(String(err));
      reject(error);
      Toast.show({
        icon: "fail",
        content: error.message,
      });
    }
  });
}
